import { useCallback } from 'react';
import * as pas from 'js/hooks/auth/pas';
import { useTranslations } from 'js/hooks/i18n';
import { useGetErrorMessage } from 'js/hooks/server';

export const useValidateTwoFactorToken = ({ onSuccess, onClose, setError, isDeviceTrusted }) => {
    const translate = useTranslations('playtech.mobile.system.2fa.');
    const getErrorMessage = useGetErrorMessage({ translate });

    return useCallback(async (values) => {
        setError();

        try {
            await pas.validateTwoFactorToken(values.token, isDeviceTrusted);
        } catch (error) {
            const errorMsg = getErrorMessage(error);

            setError(errorMsg);

            return errorMsg;
        }

        try {
            await onSuccess();

            onClose();
        } catch (error) {
            const errorMessage = getErrorMessage(error);

            setError(errorMessage);

            return errorMessage;
        }
    }, [onSuccess, onClose, setError, getErrorMessage, isDeviceTrusted]);
};
